import React, { Fragment } from "react"
import { useTheme } from "styled-components"

import Icon from "icons"

import HeroContent from "../content"
import {
  Container,
  Content,
  TopSpacer,
  Background,
  HeadingGradient,
  IconContainer,
  Subheading,
  ButtonContainer,
  FeatureHighlights,
  FeatureHighlightsMobile,
  Feature,
  FeatureSpacer,
  BottomSpace,
  FeatureImage,
  PlayText,
} from "./styles"

const FeatureItem = ({ feature }) => (
  <Feature>
    {feature.image && (
      <FeatureImage
        baseUrl={feature.image.url}
        images={[
          {
            transforms: `c_fill,g_auto,w_30,h_${Math.round(
              feature.image.aspect * 30,
            )},q_auto,f_auto,fl_lossy`,
          },
        ]}
        aspectRatio={feature.image.aspect}
      />
    )}
    <h5>{feature.label}</h5>
    <span>{feature.value}</span>
  </Feature>
)

const VideoHero = ({
  heading,
  subheading,
  variant = "Small",
  backgroundImage,
  backgroundVideo,
  backgroundVideoTransform,
  featureHighlights,
  buttonElement,
  onClick,
  elRef,
  hidePlayButton,
  dataId,
  hideOnPageLoad,
  ...props
}) => {
  let videoUrl = backgroundVideo
  let posterUrl = null
  if (backgroundVideo) {
    const [left, right] = backgroundVideo.split("/video/upload/")
    posterUrl = `${left}/video/upload/so_0,f_auto,fl_lossy,q_auto/${right}`.replace(".mp4", ".jpg")

    if (backgroundVideoTransform) {
      videoUrl = `${left}/video/upload/${backgroundVideoTransform}/${right}`
    }
  }

  const theme = useTheme()

  return (
    <Container hideOnPageLoad={hideOnPageLoad} data-exp-id={dataId} ref={elRef} {...props}>
      <div>
        {backgroundVideo && (
          <video
            autoPlay
            playsInline
            loop
            muted
            poster={posterUrl}
            title="Main decorative video"
            aria-hidden="true"
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
        )}
        {!backgroundVideo && backgroundImage && (
          <Background
            baseUrl={backgroundImage}
            images={[
              {
                transforms: "c_fill,g_north,w_1440,h_477,q_auto,f_auto,fl_lossy",
                screenSize: 1024,
              },
              {
                transforms: "c_fill,g_north,w_1023,h_509,q_auto,f_auto,fl_lossy",
                screenSize: 768,
              },
              {
                transforms: "c_fill,g_north,w_600,h_559,q_auto,f_auto,fl_lossy",
              },
            ]}
            alt="Background"
            lazy={!theme.component.onTop}
          />
        )}
        <Content variant={variant} hidePlayButton={hidePlayButton}>
          <TopSpacer onClick={onClick} hidePlayButton={hidePlayButton} />
          <HeadingGradient onClick={onClick} hidePlayButton={hidePlayButton}>
            {!hidePlayButton ? (
              <IconContainer>
                <PlayText>Play Trailer</PlayText>
                  {variant !== "Large" && <Icon id="play-icon" width={79} height={79} title="Play" />}
                  {variant === "Large" && <Icon id="play-icon-filled" width={79} height={79} title="Play" />}
              </IconContainer>
            ) : (
              <IconContainer hidePlayButton={hidePlayButton} />
            )}
            <HeroContent preheading={{}} heading={heading} />
          </HeadingGradient>
          <Subheading dangerouslySetInnerHTML={{ __html: subheading }} />
          {buttonElement && <ButtonContainer>{buttonElement}</ButtonContainer>}
          {variant === "Large" && featureHighlights && (
            <FeatureHighlights>
              {featureHighlights.map((feat, idx) => (
                <Fragment key={feat.id}>
                  <FeatureItem feature={feat} />
                  {idx < featureHighlights.length - 1 && <FeatureSpacer />}
                </Fragment>
              ))}
            </FeatureHighlights>
          )}
        </Content>
        {variant === "Large" && featureHighlights && (
          <FeatureHighlightsMobile>
            {featureHighlights.map((feat) => (
              <FeatureItem key={feat.id} feature={feat} />
            ))}
          </FeatureHighlightsMobile>
        )}
      </div>
      {variant === "Large" && <BottomSpace />}
    </Container>
  )
}

export default VideoHero
